import { PipelineItemTypeEnum } from '../types'
import { usePipelineStore } from './stores/usePipelineStore'
import { useContactTemplate } from './useContactTemplate'

interface ReturnType {
   baseTemplateIds: string[]
}

const useGetBaseTemplateIds = (pipelineId: string | null): ReturnType => {
   const { getContactTemplateId } = useContactTemplate()
   const pipelineStore = usePipelineStore()

   if (!pipelineId) {
      return {
         baseTemplateIds: [getContactTemplateId()]
      }
   }
   const pipelineModel = pipelineStore.getPipeline(pipelineId)

   const baseTemplateIds = [pipelineModel.pipelineItemTemplateId]

   const shouldIncludeContactTemplate =
      pipelineModel.pipelineItemType === PipelineItemTypeEnum.lead ||
      pipelineModel.pipelineItemType === PipelineItemTypeEnum.deal

   if (shouldIncludeContactTemplate) {
      baseTemplateIds.unshift(getContactTemplateId())
   }

   return {
      baseTemplateIds
   }
}

export default useGetBaseTemplateIds
